<div>
  <main class="leaflet-page">
    <div
      id="dcf-leaflet-content"
      #component
    ></div>
    @if (!initialized) {
      <div class="dcf-spinner-container">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    }
  </main>
</div>
